import React, { useEffect, useState } from 'react';
import { Star, ChevronDown, ChevronUp } from 'lucide-react';
import api from '@/utils/api';
import { ptDate } from '@/utils/pioneerDates';

const Row = ({ p }) => (
  <tr className="border-t border-slate-100" data-testid={`pioneer-row-${p.employer_id}`}>
    <td className="py-2 pr-3 font-semibold text-slate-800">{p.company_name}</td>
    <td className="py-2 pr-3 text-slate-500">{p.email}</td>
    <td className="py-2 pr-3">{ptDate(p.started_at)}</td>
    <td className="py-2 pr-3 font-semibold">{ptDate(p.ends_at)}</td>
    <td className="py-2 pr-3">
      {p.active
        ? <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-700">{p.days_left} {p.days_left === 1 ? 'dia' : 'dias'}</span>
        : <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-500">Terminado</span>}
    </td>
    <td className="py-2 text-right">{p.jobs_count}</td>
  </tr>
);

export const PioneerList = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get('/admin/pioneers').then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);
  const activeCount = items.filter((i) => i.active).length;
  return (
    <div className="mb-6 rounded-xl border border-slate-200 bg-white" data-testid="pioneer-list">
      <button onClick={() => setOpen((o) => !o)} className="flex w-full items-center gap-2 px-5 py-4 text-left" data-testid="pioneer-list-toggle">
        <Star className="h-4 w-4 text-blue-700" />
        <span className="flex-1 font-bold text-slate-900">Empresas Pioneiras · {activeCount} activas · {items.length - activeCount} terminadas</span>
        {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
      {open && (
        <div className="overflow-x-auto px-5 pb-4">
          {items.length === 0 ? <p className="text-sm text-slate-500" data-testid="pioneer-list-empty">Ainda não há empresas pioneiras.</p> : (
            <table className="w-full text-sm">
              <thead className="text-left text-xs uppercase text-slate-400">
                <tr><th className="pb-2">Empresa</th><th className="pb-2">Email</th><th className="pb-2">Aceite a</th><th className="pb-2">Termina a</th><th className="pb-2">Restam</th><th className="pb-2 text-right">Vagas</th></tr>
              </thead>
              <tbody>{items.map((p) => <Row key={p.employer_id} p={p} />)}</tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};
